import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  COMPANY_STORAGE_LOCATION_LIST,
  COMPANY_STORAGE_LOCATION_DATA,
  COMPANY_STORAGE_LOCATION_CREATE,
  COMPANY_STORAGE_LOCATION_UPDATE,
  COMPANY_STORAGE_LOCATION_DELETE,
} from "./actionType";
import {
  companyStorageLocationListSuccess,
  companyStorageLocationListFailure,
  companyStorageLocationDataSuccess,
  companyStorageLocationDataFailure,
  companyStorageLocationCreateSuccess,
  companyStorageLocationCreateFailure,
  companyStorageLocationUpdateSuccess,
  companyStorageLocationUpdateFailure,
  companyStorageLocationDeleteSuccess,
  companyStorageLocationDeleteFailure,
} from "./action";
import {
  companyStorageLocationListApi,
  companyStorageLocationDataApi,
  companyStorageLocationCreateApi,
  companyStorageLocationUpdateApi,
  companyStorageLocationDeleteApi,
} from "../../helpers/fakebackend_helper";

function* listCompanyStorageLocation() {
  try {
    const response = yield call(companyStorageLocationListApi);
    yield put(companyStorageLocationListSuccess(response));
  } catch (error) {
    yield put(companyStorageLocationListFailure(error));
  }
}

function* getCompanyStorageLocationData({ payload }) {
  try {
    const response = yield call(companyStorageLocationDataApi, payload);
    yield put(companyStorageLocationDataSuccess(response));
  } catch (error) {
    yield put(companyStorageLocationDataFailure(error));
  }
}

function* createCompanyStorageLocation({ payload }) {
  try {
    const response = yield call(companyStorageLocationCreateApi, payload);
    yield put(companyStorageLocationCreateSuccess(response));
  } catch (error) {
    yield put(companyStorageLocationCreateFailure(error));
  }
}

function* updateCompanyStorageLocation({ payload }) {
  try {
    const response = yield call(companyStorageLocationUpdateApi, payload);
    yield put(companyStorageLocationUpdateSuccess(response));
  } catch (error) {
    yield put(companyStorageLocationUpdateFailure(error));
  }
}

function* deleteCompanyStorageLocation({ payload }) {
  try {
    const response = yield call(companyStorageLocationDeleteApi, payload);
    yield put(companyStorageLocationDeleteSuccess(response));
  } catch (error) {
    yield put(companyStorageLocationDeleteFailure(error));
  }
}

function* watchList() { yield takeEvery(COMPANY_STORAGE_LOCATION_LIST, listCompanyStorageLocation); }
function* watchData() { yield takeEvery(COMPANY_STORAGE_LOCATION_DATA, getCompanyStorageLocationData); }
function* watchCreate() { yield takeEvery(COMPANY_STORAGE_LOCATION_CREATE, createCompanyStorageLocation); }
function* watchUpdate() { yield takeEvery(COMPANY_STORAGE_LOCATION_UPDATE, updateCompanyStorageLocation); }
function* watchDelete() { yield takeEvery(COMPANY_STORAGE_LOCATION_DELETE, deleteCompanyStorageLocation); }

export default function* CompanyStorageLocationSaga() {
  yield all([
    fork(watchList),
    fork(watchData),
    fork(watchCreate),
    fork(watchUpdate),
    fork(watchDelete),
  ]);
}
